import React, { useMemo, useRef, useState } from 'react';
import Modal, { IModalProps } from '../components/elements/modal';

type IModalStates = Pick<
  IModalProps,
  | 'show'
  | 'children'
  | 'backdrop'
  | 'scrollable'
  | 'size'
  | 'title'
  | 'description'
  | 'yellowHeader'
  | 'modalIcon'
  | 'onClose'
  | 'showCloseButton'
  | 'autoCloseAfter'
  | 'showDescription'
  | 'showBackButton'
  | 'onBack'
  | 'classes'
  | 'showTitleSection'
  | 'hidePanelStyles'
  | 'isHeadRounded'
> & { static?: boolean };

function useModal() {
  const [modalState, setModalState] = useState<IModalStates>({
    show: false,
    children: null,
    backdrop: true,
    scrollable: false,
    size: 'md',
    title: '',
    description: '',
    yellowHeader:false,
    modalIcon: null,
    onClose: undefined,
    showCloseButton: true,
    static: false,
    autoCloseAfter: undefined,
    showBackButton: false,
    showDescription: true,
    onBack: () => { },
    classes: '',
    showTitleSection: true,
    hidePanelStyles: false,
    isHeadRounded: true
  });

  const modalStateRef = useRef(modalState);
  modalStateRef.current = modalState;

  // const updateModalStates = (states: Partial<IModalStates>) => {
  //   setModalState({ ...modalState, ...states });
  // };
const updateModalStates = (states: Partial<IModalStates>) => {
  setModalState(prev => ({ ...prev, ...states }));
};
  // const showModal = () => {
  //   setModalState({
  //     ...modalState,
  //     show: true
  //   });
  // };

  // const closeModal = () => {
  //   setModalState({
  //     ...modalState,
  //     show: false
  //   });
  // };
const showModal = () => {
  setModalState(prev => ({
    ...prev,
    show: true
  }));
};

const closeModal = () => {
  setModalState(prev => ({
    ...prev,
    show: false
  }));
};


  const ModalComponent = useMemo(() => {
    const Component = () => {
      const state = modalStateRef.current;

      return (
        <Modal
          show={state.show ?? false}
          onClose={state.onClose || closeModal}
          title={state.title}
          description={state.description}
          modalIcon={state.modalIcon}
          yellowHeader={state.yellowHeader}
          scrollable={state.scrollable}
          size={state.size}
          backdrop={state.backdrop}
          showCloseButton={state.showCloseButton}
          staticMode={state.static}
          autoCloseAfter={state.autoCloseAfter}
          showBackButton={state.showBackButton}
          showDescription={state.showDescription}
          onBack={state.onBack}
          classes={state.classes}
          showTitleSection={state.showTitleSection}
          hidePanelStyles={state.hidePanelStyles}
          isHeadRounded={state.isHeadRounded}>
          {state.children}
        </Modal>
      );
    };

    Component.displayName = 'ModalComponent';
    return Component;
  }, []);
  return { ModalComponent, showModal, closeModal, updateModalStates };
}
export default useModal;
